import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
//import 'quill/dist/quill.bubble.css' // for bubble theme
import InputError from '@/components/InputError.vue'

import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import {
    library
} from '@fortawesome/fontawesome-svg-core'

// solid
import {
    faHeart,
    faClock,
    faPlus,
    faSearch,
    faSync,
    faSlidersH,
    faUser,
    faUsers,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faCalendar,
    faComment,
    faStore,
    faCogs,
    faUndo,
    faRedo,
    faSave,
    faSignInAlt,

    faReply,
    faShare,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faCode,
    faParagraph,
    faHeading,
    faListUl,
    faListOl,
    faTasks,
    faDotCircle,
    faQuoteRight,
    faPhotoVideo,
    faCheckSquare,
    faExternalLinkAlt,
    faLink,
    faLaugh,
    faFrown,
    faCheck,
    faTimes,
} from '@fortawesome/free-solid-svg-icons'
import {
    faHeart as farHeart,
} from '@fortawesome/free-regular-svg-icons'
import {
    faFacebookSquare,
    faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
    faExternalLink,
    faUsersClass,
    faBallotCheck,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faInventory,
    faBoxFull,
    faSignOut,

    faH1,
    faH2,
    faH3,
//    faH4,
    faText,
} from '@fortawesome/pro-solid-svg-icons'
import {
    faCommentAltLines,
} from '@fortawesome/pro-regular-svg-icons'

library.add(
    // free-solid
    faHeart,
    faClock,
    faPlus,
    faSearch,
    faSlidersH,
    faSync,
    faUser,
    faUsers,
    faChevronLeft,
    faChevronRight,
    faDownload,
    faCalendar,
    faComment,
    faStore,
    faCogs,
    faUndo,
    faRedo,
    faSave,
    faSignInAlt,

    faReply,
    faShare,
    faBold,
    faItalic,
    faStrikethrough,
    faUnderline,
    faCode,
    faParagraph,
    faHeading,
    faListUl,
    faListOl,
    faTasks,
    faDotCircle,
    faQuoteRight,
    faPhotoVideo,
    faCheckSquare,
    faExternalLinkAlt,
    faLink,
    faLaugh,
    faFrown,
    faCheck,
    faTimes,

    // free-regular
    farHeart,

    // free-brands
    faFacebookSquare,
    faTwitter,

    // pro-solid
    faExternalLink,
    faUsersClass,
    faBallotCheck,
    faText,
    faChevronDoubleLeft,
    faChevronDoubleRight,
    faInventory,
    faBoxFull,
    faSignOut,

    faH1,
    faH2,
    faH3,
//    faH4,

    // pro-regular
    faCommentAltLines
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-cropper', VueCropper)
Vue.use(VuejsDialog)
Vue.component('InputError', InputError)
Vue.use(VueQuillEditor)

const requireComponent = require.context(
    './',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
})
